import { render, staticRenderFns } from "./SimulacaoEditCredito.vue?vue&type=template&id=3b2858f9"
import script from "./SimulacaoEditCredito.vue?vue&type=script&lang=js"
export * from "./SimulacaoEditCredito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports